import React, { useContext, useState } from "react";
import {
  MenuShrinkContext,
  MenuToggleContext,
} from "contexts/SideMenuToggleContext";

import { Link } from "react-router-dom";
import NavLinks from "./NavlLinks";

import Favicon from "assets/brandings/Favicon.png";
import HeaderLogo from "assets/brandings/Logo.png";

import { FiArrowRightCircle, FiArrowLeftCircle } from "react-icons/fi";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

const Sidebar = () => {
  const { toggleShrink, setToggleShrink } = useContext(MenuShrinkContext);
  const { toggleMenu } = useContext(MenuToggleContext);
  const [show, setShow] = useState("");
  const handleToggle = () => {
    setToggleShrink(!toggleShrink);
  };
  return (
    <aside
      className={`sidebar  fixed ${
        toggleMenu ? "left-0" : "-left-56"
      } z-30  md:left-0 top-0 transition-all duration-300   overflow-auto  bg-[#021349]
      h-full whitespace-nowrap  flex flex-col gap-6 justify-between  py-4 pb-7 ${
        toggleShrink ? "w-16" : "w-52"
      }`}
    >
      <div className="flex  flex-col gap-10 px-4">
        <div className="site-branding h-8 flex items-center ">
          <Link to={"/"} className="flex gap-2 items-left h-full">
            {!toggleShrink ? (
              <img
                src={HeaderLogo}
                alt="SR Inventory"
                className="site-logo  h-fit w-36  object-contain"
              />
            ) : (
              <img
                src={Favicon}
                alt="SR Inventory"
                className="site-logo h-full w-8"
              />
            )}
          </Link>
        </div>
        <div className="flex flex-col  relative  h-full  mt-5   gap-6 primary-menu">
          {NavLinks.map((item, index) => {
            if (item.children) {
              return (
                <div
                  key={index}
                  className="flex items-center  text-white menu-item  cursor-pointer"
                  onClick={() =>
                    show === item.link ? setShow("") : setShow(item.link)
                  }
                  // onBlur={(e) => {}}
                >
                  <div className="flex items-center gap-3 w-full">
                    <button
                      type="button"
                      className="text-2xl"
                      title={item.title}
                    >
                      {item.icon}
                    </button>

                    {!toggleShrink && item.title}
                  </div>
                  <div
                    className={`${
                      show === item.link
                        ? " opacity-100 translate-0   z-50"
                        : "opacity-0 -translate-y-4 -z-50 collapse"
                    } ease-in-out transition-all duration-300 delay-75 fixed    bg-[#021349] 
                     rounded-r ${
                       toggleShrink ? "left-[65px]" : "left-[208.5px]"
                     } w-fit sub-menu`}
                  >
                    {item.children.map((childItem, count) => {
                      return (
                        <li
                          key={count}
                          className="flex items-center  border-b  text-white px-4
                            menu-item px  py-4 hover:bg-gray-300 hover:text-[#021349] rounded-sm "
                        >
                          <Link
                            to={childItem.link}
                            className="flex items-center gap-3  menu-link "
                          >
                            {childItem.title}
                          </Link>
                        </li>
                      );
                    })}
                  </div>

                  {!toggleShrink && (
                    <MdOutlineKeyboardArrowDown
                      className={`${
                        show === item.link ? "-rotate-90" : "rotate-0"
                      } transition-all  ease-in text-2xl`}
                    />
                  )}
                </div>
              );
            } else
              return (
                <div
                  key={index}
                  className="flex items-center text-white menu-item"
                >
                  <Link
                    to={item.link}
                    className="flex items-center gap-3 menu-link"
                  >
                    <button
                      type="button"
                      className="text-2xl"
                      title={item.title}
                    >
                      {item.icon}
                    </button>
                    {!toggleShrink && item.title}
                  </Link>
                </div>
              );
          })}
        </div>
      </div>

      <div className="text-white relative  flex gap-3 items-center px-4 toggle-wrapper">
        <div className="text-2xl  -bottom-[117px]">
          <button
            type="button"
            className="md:block hidden"
            onClick={handleToggle}
          >
            {toggleShrink ? (
              <FiArrowRightCircle />
            ) : (
              <span className="flex items-center gap-3">
                <FiArrowLeftCircle />
                <span className="text-base">Collapse Menu</span>
              </span>
            )}
          </button>
        </div>
      </div>
    </aside>
  );
};
export default Sidebar;
